import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'ls0004',
    ecrans: ['00-2'],
    params: ['id',
    '?demcleint']
});
